export const resourcesFooter = {
    title: 'Sadžaj',
    links: [
        {
            title: 'Početna stranica',
            link: '/home',
        },
        {
            title: 'Kategorije',
            link: '/user/kategorija',
        },
        {
            title: 'Kvizovi',
            link: '/user/kviz',
        },
        {
            title: 'Testovi za upis srednju školu',
            link: '/user/oblast/54ba3d07-da2b-44b9-a734-a8c835cae69b',
        },
        {
            title: 'Testovi znanja iz automehanike',
            link: '/user/oblast/6721c005-fe63-4dd7-ae82-1a31986495ec',
        },
    ],
};

export const helpFooter = {
    title: 'Pomoć',
    links: [
        {
            title: 'O nama i kontakt',
            link: '/user/contact',
        },
        {
            title: 'Saradnja',
            link: '/user/contact',
        },
    ],
};

export const legalFooter = {
    title: 'Pravni dokumenti',
    links: [
        {
            title: 'Uslovi korišćenja',
            link: '/user/terms',
        },
        {
            title: 'Politika privatnosti',
            link: '/user/privacy',
        },
    ],
};
